export default __webpack_public_path__ + "static/media/shop.8de98609.jpg";